var exports = {
  "G": "AvatarStack__abnfAa",
  "Z": "AggregateLabels__NW5ETT",
};

module.exports = exports;
